<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import SecondaryButton from "@/components/SecondaryButton.vue";
import MainForm from "@/components/MainForm.vue";
import FormTitle from "@/components/FormTitle.vue";
export default {
	components: {
		SecondaryButton,
		FormTitle,
		MainForm,
	},
	data() {
		return {
			showForm: false,
			listed: false,
			action: "Agregar",
			regions: [],
			region: {
				id: { name: "Id", value: null },
				name: { name: "Nombre", value: null },
				territory_id: { name: "Territorio", value: null, options: {} },
			},
		};
	},
	created() {
		this.loadFilter(true);
	},
	computed: {
		...mapGetters({
			isLoading: "loading/isLoading",
			readProfile: "auth/readUser",
			//READ_FILTER
			readTerritories: "getTerritories/readTerritories",
			//READ_REGIONS
			readRegions: "regionsStore/readRegions",
			//READ_ERRORS
			readError: "regionsStore/readError",
		}),
	},
	methods: {
		...mapMutations({
			setLoading: "loading/SET_LOADING",
			//SET_FILTERS_ID
			setRegionId: "regionsStore/SET_ID",
			setFilter: "regionsStore/SET_FILTER",
			setTerritoryId: "getTerritories/SET_ID",

			//SET_REGIONS
			setCreateRegion: "regionsStore/SET_REGION",
			setUpdateRegion: "regionsStore/SET_REGION",
			setUpdateId: "regionsStore/SET_ID",
			setDeleteId: "regionsStore/SET_ID",

			//SET_ERRORS
			setError: "regionsStore/SET_ERROR",
		}),
		...mapActions({
			//GET_FILTERS
			getTerritories: "getTerritories/getTerritories",
			//REGIONS
			regionActions: "regionsStore/regionActions",
		}),
		getImage(image) {
			return `${require(`@/assets/images/views${this.$route.path.toUpperCase()}/${image}`)}`;
		},
		loadFilter(start = false) {
			this.clearErrors();
			this.setLoading(true);
			this.listed = false;
			this.region.territory_id.value = null;
			this.region.territory_id.options = {};

			//TERRITORIES
			this.setTerritoryId(null);
			this.getTerritories()
				.then((response) => {
					if (response) {
						if (this.readTerritories.length > 0) {
							for (let t in this.readTerritories) {
								this.region.territory_id.options[
									this.readTerritories[t].id
								] = this.readTerritories[t].name;
							}
							if (start) {
								this.region.territory_id.value =
									this.readProfile.territory_id;
								this.loadRegions(true);
							} else {
								this.loadRegions();
							}
						}
					}
				})
				.finally(() => {
					this.setLoading(false);
				});
		},
		loadRegions(start = false) {
			this.clearErrors();
			this.setLoading(true);
			this.listed = false;
			let territory = this.region.territory_id.value;

			this.regions = [];

			//REGIONS
			this.setRegionId(null);
			this.setFilter(territory);
			this.regionActions("getRegions")
				.then((response) => {
					if (response) {
						if (this.readRegions.length > 0) {
							this.regions = this.readRegions;
						} else if (start) {
							this.loadFilter();
						}
					}
				})
				.finally(() => {
					this.listed = true;
					this.setLoading(false);
				});
		},
		toggleForm() {
			this.clearErrors();
			this.showForm = !this.showForm;
		},
		update(data) {
			this.clearErrors();
			this.toggleForm();
			this.action = "Actualizar";
			for (let r in this.region) {
				this.region[r]["value"] = data[r];
			}
		},
		remove(region) {
			this.clearErrors();
			this.setLoading(true);

			this.$swal({
				title: "¿Desea eliminar esta Región?",
				icon: "warning",
				showCancelButton: true,
				cancelButtonText: "Cancelar",
				confirmButtonText: "Aceptar",
			}).then((result) => {
				if (result.isConfirmed) {
					this.setDeleteId(region.id.value || region.id);
					this.regionActions("deleteRegion").then((result) => {
						if (result) {
							this.loadRegions();
							this.$swal({
								icon: "success",
								title: `La Región ${
									region.name.value || region.name
								} ha sido eliminado correctamente.`,
								showConfirmButton: false,
								timer: 3000,
							});
							this.clear();
							if (this.showForm) this.toggleForm();
						}
					});
				}
			});
			this.setLoading(false);
		},
		submit() {
			this.clearErrors();
			this.setLoading(true);
			let region = this.region;
			let output = {};

			for (let r in region) {
				output[r] = region[r].value;
			}

			if (this.action == "Agregar") {
				this.setCreateRegion(output);
				this.regionActions("createRegion").then((result) => {
					if (result) {
						this.loadRegions();
						this.clear();
						this.toggleForm();
						this.$swal({
							icon: "success",
							title: `La Región ${output.name} ha sido creada con éxito.`,
							showConfirmButton: false,
							timer: 3000,
						});
					}
				});
			} else {
				this.setUpdateId(output.id);
				this.setUpdateRegion(output);

				this.regionActions("updateRegion").then((result) => {
					if (result) {
						this.loadRegions();
						this.clear();
						this.toggleForm();
						this.$swal({
							icon: "success",
							title: `La Región ${output.name} se actualizó con éxito.`,
							showConfirmButton: false,
							timer: 3000,
						});
					}
				});
			}
			this.setLoading(false);
		},
		clear() {
			for (let r in this.region) {
				this.region[r].value = null;
			}
			this.action = "Agregar";
		},
		clearErrors() {
			this.setError(null);
		},
	},
};
</script>

<template>
	<div class="main">
		<div
			v-if="showForm"
			class="modal-form fixed right-0 top-0 p-3 md:p-5 w-full h-full z-30 overflow-y-auto"
		>
			<div
				class="content-wrap bg-white border-2 border-gray px-6 pt-10 pb-6 shadow-md absolute max-w-3xl mx-auto right-0 left-0"
			>
				<SecondaryButton
					@click.native="[toggleForm(), clear()]"
					text="x"
					buttonColor="bg-red"
					class="close rounded-full h-10 absolute right-6 top-6 flex-none"
				/>
				<form-title
					:action="action"
					text="Punto de "
					textBold="Venta"
					:name="region.name.value"
				></form-title>
				<!-- DISPLAY FORM -->
				<form class="grid grid-cols-2 gap-5 items-center">
					<label
						class="col-span-2 text-lg"
						:for="key"
						v-for="(r, key, index) in region"
						:key="key"
						v-show="key != 'id'"
						ref="labels"
					>
						<textarea
							v-if="key != 'territory_id'"
							:ref="index"
							:required="key != 'id'"
							class="w-full px-4 py-2 text-lg bg-gray-light rounded-md"
							type="text"
							:name="key"
							:placeholder="r.name"
							v-model="r.value"
							rows="2"
							v-capitalizeInput
						/>
						<select
							@change="loadRegions()"
							class="w-full px-4 py-2 text-lg bg-gray-light rounded-md h-12"
							:name="r.name"
							:id="key"
							v-if="key == 'territory_id'"
							v-model="r.value"
						>
							<option disabled value="null">
								Seleccionar territorio
							</option>
							<option
								v-for="(option, index) in r.options"
								:key="index"
								:value="index"
								v-capitalizeWords="option"
							></option>
						</select>
					</label>
					<span
						v-if="readError"
						class="block mt-5 red text-center b col-span-2"
						>{{ readError }}</span
					>
					<div
						class="col-span-2 mt-6 flex flex-col items-center md:flex-row justify-evenly"
					>
						<SecondaryButton
							v-if="action == 'Actualizar'"
							@click.native="remove(region)"
							text="Eliminar"
							buttonColor="bg-red"
							class="flex-none mb-3 md:mb-0 md:mr-2"
						/>
						<SecondaryButton
							@click.native="[toggleForm(), clear()]"
							v-else
							text="Cancelar"
							buttonColor="bg-red"
							class="flex-none mb-3 md:mb-0 md:mr-2"
						/>
						<SecondaryButton
							:text="action"
							@click.native="submit"
							class="flex-none"
						/>
					</div>
				</form>
			</div>
		</div>
		<main-form
			v-on:toggleForm="toggleForm"
			:action="action"
			text="Regiones"
			textBold="Red Única"
		>
		</main-form>
		<table
			class="block lg:table table-auto w-full"
			v-if="!isLoading && regions.length > 0"
			id="no-more-tables"
		>
			<thead class="block lg:table-header-group elektra-bg-red">
				<tr class="block lg:table-row border border-gray">
					<th
						class="block text-white lg:table-cell b border-r border-gray py-3 px-1"
						v-for="(field, key) in region"
						:key="key"
						v-show="key != 'id'"
					>
						{{ field.name }}
					</th>
					<th
						class="block lg:table-cell b text-white border-r py-3 px-1"
					>
						Acciones
					</th>
				</tr>
			</thead>
			<tbody class="block md:flex flex-wrap lg:table-row-group">
				<tr
					class="block odd:bg-gray-light hover:bg-orange lg:table-row border-t border-b border-gray box-border"
					:class="
						regions.length > 1
							? 'w-full md:w-1/2 lg:w-full'
							: 'w-full'
					"
					v-for="(r, i) in regions"
					:key="i"
				>
					<td
						class="block before:text-center before:justify-center first:border-l lg:table-cell text-center border-r border-gray-light py-3 px-1"
						:class="{ 'green b': key == 'id' }"
						v-for="(field, key) in region"
						:key="key"
						v-show="key != 'id'"
						v-capitalizeWords="r[key]"
					></td>
					<td
						class="flex justify-evenly px-1 items-center py-3 icons lg:table-cell"
					>
						<div class="w-full flex justify-evenly items-center">
							<span
								class="title-hint"
								aria-label="Da clic aquí para editar esta Región"
							>
								<font-awesome-icon
									@click="update(r)"
									class="green hover:text-white text-3xl md:text-2xl cursor-pointer"
									icon="fa-solid fa-pen-to-square"
								/>
							</span>
							<span
								class="title-hint"
								aria-label="Da clic aquí para eliminar esta Región"
							>
								<font-awesome-icon
									@click="remove(r)"
									class="red hover:text-white text-3xl md:text-2xl cursor-pointer"
									icon="fa-solid fa-trash-can"
								/>
							</span>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<span v-else-if="listed" class="block my-3 blue text-center b"
			>No se encontraron regiones</span
		>
	</div>
</template>

<style lang="scss" scoped>
/*
	Label the data
	*/

@media (max-width: 1023px) {
	$fields: 1 "Nombre", 2 "Territorio";

	@each $i, $field in $fields {
		#no-more-tables td:nth-child(#{$i + 1}):before {
			content: $field;
		}
	}
}
</style>
